// used for setting query values without rerendering components  
export const updateUrlQuery = (query, value) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set(query, value);
  window.history.replaceState({}, '', '/checkout/?' + searchParams.toString());
};

export const removeUrlQuery = (query) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(query);
  const queryString = searchParams.toString();
  const path = queryString ? `/checkout/?${queryString}` : '/checkout/';
  window.history.replaceState({}, '', path);
};
